import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export type ExportFormat = 'xlsx' | 'csv' | 'pdf';

/** Cross-module data export client. Streams a filtered file download. */
export const exportApi = {
  /** Datasets the current user is permitted to export (drives UI gating). */
  async datasets(): Promise<Array<{ dataset: string; module: string; permission: string }>> {
    return (await apiClient.get<ApiSuccess<Array<{ dataset: string; module: string; permission: string }>>>('/exports/datasets')).data.data;
  },

  /** Download a dataset export honouring the supplied filters. */
  async download(dataset: string, format: ExportFormat, filters: Record<string, unknown> = {}): Promise<void> {
    const params = new URLSearchParams({ format });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
    }
    const res = await apiClient.get(`/exports/${dataset}?${params.toString()}`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${dataset}-export.${format}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
